module.exports = __webpack_public_path__ + "static/media/step_003.7e83354f.png";